import * as Common from '@/tenant/common';

export class ExchangeRate extends Common.MasterBase{
  constructor(){
    super('ExchangeRate');
    this.state = Common.MasterBaseStatus.NotPosted;
    this.workflowStateId = Common.MasterBaseStatus.NotPosted;
  }
  public currency: string = '';
  public startDate: Date = new Date().getCalendarDate();
  public rate: number = 0;
  public isRevalueRate: boolean = false;

  public copy():any {
    const temp = super.copy() as ExchangeRate;
    temp.state = Common.MasterBaseStatus.NotPosted;
    temp.workflowStateId = Common.MasterBaseStatus.NotPosted;
    return temp;
  }
}

export class ExchangeRateQuery extends Common.LoadQuery {
  constructor(){
    super('ExchangeRateQuery',ExchangeRate);
    this.sort = 'currency';
  }

  public currency: string = '';
  public startDateFrom: Date = null;
  public startDateTo: Date = null;
  public initialSavedOnFrom: Date = null;
  public initialSavedOnTo: Date = null;
  public lastUpdatedOnFrom: Date = null;
  public lastUpdatedOnTo: Date = null;
  public state: Common.MasterBaseStatus = null;
  public holder: string = '';
  public auditNo: string ='';
}

export class GetExchangeRateQuery extends Common.Query{
  constructor(){
    super('GetExchangeRateQuery', new Common.ModelBinder(Common.ExchangeRate, false));
  }
  public currency: string = '';
  public startDate: Date = null;
}

export class ExchangeRateImportQuery extends Common.ImportQuery {
  constructor(sheetName:string){
    super("",null);
    this.className = "ExchangeRateImportQuery";
    this.sheetName = sheetName;
    this.hasLicenseTrade = false;
  }
  public sheetName: string;
  public hasLicenseTrade: boolean;
}

export class ExchangeRateExportQuery extends Common.ExportQuery {
  constructor(sheetName:string, loadQuery:Common.LoadQuery){
    super("",loadQuery);
    this.className = "ExchangeRateExportQuery";
    this.loadQuery = loadQuery;
    this.sheetName = sheetName;
    this.hasLicenseTrade = false;
  }
  public loadQuery: Common.LoadQuery;
  public sheetName: string;
  public hasLicenseTrade: boolean;
}